export const MODAL_ACTION_TYPES = {
  MODAL_SHOW: 'modal_show',
  MODAL_HIDE: 'modal_hide'
};

export const showModalAction = ({ modalId, ...payload }) => ({
  type: MODAL_ACTION_TYPES.MODAL_SHOW,
  payload: { modalId, ...payload }
});

export const hideModalAction = modalId => ({
  type: MODAL_ACTION_TYPES.MODAL_HIDE,
  payload: { modalId }
});
